import Registry from "../registry";
import React from "react";
import Images from "../components/fields/Images";
import utils from "../lib/utils";
import t from "tcomb-form";

const image = {
  name: "Image",
  group: "Content",
  options: {
    file_limit: {
      label: "File Limit",
      help: "Leave blank for no limit"
    },
    publicUrl: {
      label: "Public URL",
      help: "Provide a publicly accessible url through the api.",
      type: "boolean"
    },
    forWeb: {
      label: "Optimize for Web",
      help: "Resizes and optimizes images to be used on the web.",
      type: "boolean"
    }
  },
  schema: part => {
    return {
      type: "list",
      of: {
        type: "structure",
        fields: {
          name: { type: "string" },
          url: { type: "string" },
          size: { type: "number" }
        }
      },
      factory: t.form.Textbox,
      component: locals => (
        <Images
          limit={parseInt(part.file_limit) || 0}
          accepted="image/*"
          value={locals.value || []}
          publicUrl={part.publicUrl || false}
          forWeb={part.forWeb || false}
          onChange={locals.onChange}
        />
      ),
      render: ({ value }) => {
        const file = Array.isArray(value) ? value[0] : value;
        if (!file || !file.name || !file.url) {
          return (
            <div className="no-image-fallback">
              <i className="ion-image" />
            </div>
          );
        }

        return <img src={utils.fileUrl(file)} />;
      }
    };
  }
};

Registry.register("image", image);
export default image;



// WEBPACK FOOTER //
// ./app/parts/image.js